import { render, staticRenderFns } from "./ProductCategoriesAndSearch.vue?vue&type=template&id=0f615f93&scoped=true"
import script from "./ProductCategoriesAndSearch.vue?vue&type=script&lang=ts"
export * from "./ProductCategoriesAndSearch.vue?vue&type=script&lang=ts"
import style0 from "./ProductCategoriesAndSearch.vue?vue&type=style&index=0&id=0f615f93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f615f93",
  null
  
)

export default component.exports